import PropTypes from 'prop-types';

const archetypeTypes = PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
}).isRequired;

export default archetypeTypes;
